(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('GlosaConteudo', GlosaConteudo);

  function GlosaConteudo($stateParams, GlosaService, $uibModal, $rootScope, $scope, $state) {

    var vm = this;

    vm.init = init;
    vm.add = add;
    vm.populate = populate;
    vm.refresh = refresh;

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.paiDK = $stateParams.paiDK;
      vm.refresh();
      $scope.$on('event:changeViewMode', function () {
        vm.refresh();
      });
    }

    function refresh() {
      vm.viewMode = $rootScope.viewMode;
      vm.registrosList = [];
      vm.populate(vm.registrosList);
    }

    function add(member) {
      vm.paiDK = member.linhaDK;
      vm.populate(member.subregistros);
    }

    function populate(lista) {

      if (lista.length === 0) {

        GlosaService.getRegistros(vm.promotorSelecionado.originalObject.pessDk,
          vm.relDkSelecionado,vm.paiDK).then(function (data) {
            data.forEach(function(e) {
              e.subregistros = [];
              e.pessoaDk = vm.promotorSelecionado.originalObject.pessDk;
              e.relatorioSelecionadoDk = vm.relDkSelecionado;
              lista.push(e);
            });
          });
        }
      }
    }
  })();
